import protoRoot from "../proto-root";
import ActivityLogVideoPreview from "../private/ActivityLogVideoPreview";

const name = "stopVideoRecordingRPCResponse";

function create({ result, thumbnailData, event }) {
  const StopVideoRecording = protoRoot.lookupType(
    "comm.StopVideoRecordingRPCResponse"
  );
  const Result = StopVideoRecording.lookupEnum("Result");

  const response = StopVideoRecording.create({
    result: Result.values[result],
    video: ActivityLogVideoPreview.create({ thumbnailData, event })
  });
  return { payload: response, name };
}

export default {
  create,
  name
};

// message StopVideoRecordingRPCResponse {
//     Result result = 1;
//     ActivityLogVideoPreview video = 2;
// }
